import ROUTES from '../routes';
import UserListPage from '../hoc/user-list/user-list';
import UserDetails from '../hoc/user-list/user-details';
import Administration from '../hoc/administration/administration';
import UserRolesPage from '../hoc/user-roles/user-roles';
import RoleEditHOC from '../hoc/user-roles/role-edit';
import RoleCreateHOC from '../hoc/user-roles/role-create';
import EmployeeProfile from '../hoc/settings/profile/profile';
import ChangeLogs from '../hoc/change-logs/change-logs';
import ClientsList from '../hoc/clients/clients';
import ClientPanel from '../hoc/clients/client';
import CreateClientPanel from '../hoc/clients/create';
import NotificationSettings from '../hoc/notification-settings/notification-settings';
import Security from '../hoc/security/security';
import SecurityLocks from '../hoc/security/locks';
import SecurityLockForm from '../hoc/security/form';
import SecurityLogs from '../hoc/security/logs';
import SecurityLogForm from '../hoc/security/logs-form';
import AnonymisationLogs from '../hoc/anonymisation-logs/anonymisation-logs';

const AdministrationRoutes = {
  path: ROUTES.ADMINISTRATION,
  element: <Administration />,
  children: [
    {
      path: ROUTES.USER_LIST,
      element: <UserListPage />,
      children: [
        {
          path: ROUTES.USER_EDIT,
          element: <UserDetails />,
        },
        {
          path: ROUTES.USER_ADD,
          element: <UserDetails />,
        },
      ],
    },
    {
      path: ROUTES.USER_ROLES,
      element: <UserRolesPage />,
      children: [
        {
          path: ROUTES.ROLE_EDIT,
          element: <RoleEditHOC />,
        },
        {
          path: ROUTES.ROLE_ADD,
          element: <RoleCreateHOC />,
        },
      ],
    },
    {
      path: ROUTES.CHANGE_LOGS,
      element: <ChangeLogs />,
    },
    {
      path: ROUTES.NOTIFICATION_SETTINGS,
      element: <NotificationSettings />,
    },
    {
      path: ROUTES.SETTINGS_PROFILE,
      element: <EmployeeProfile />,
    },
    {
      path: ROUTES.CLIENTS_LIST,
      element: <ClientsList />,
      children: [
        {
          path: ROUTES.CLIENTS_CREATE,
          element: <CreateClientPanel />,
        },
        {
          path: ROUTES.CLIENTS_EDIT,
          element: <ClientPanel />,
        },
      ],
    },
    {
      path: ROUTES.SECURITY,
      element: <Security />,
      children: [
        {
          path: ROUTES.SECURITY_LOCKS,
          element: <SecurityLocks />,
          children: [
            {
              path: ROUTES.SECURITY_LOCKS_CREATE,
              element: <SecurityLockForm type="locks" />,
            },
            {
              path: ROUTES.SECURITY_LOCKS_ITEM,
              element: <SecurityLockForm type="locks" />,
            },
          ],
        },
        {
          path: ROUTES.SECURITY_LOGS,
          element: <SecurityLogs />,
          children: [
            {
              path: ROUTES.SECURITY_LOGS_CREATE,
              element: <SecurityLockForm type="logs" />,
            },
            {
              path: ROUTES.SECURITY_LOGS_ITEM,
              element: <SecurityLogForm />,
            },
          ],
        },
      ],
    },
    {
      path: ROUTES.ANONYMISATION,
      element: <AnonymisationLogs />,
    },
  ],
};

export default AdministrationRoutes;
